import React from "react";
import AdminDashBoard from "../components/admin/AdminDashBoard";

export default function AdminMain() {
  return (
    <>
      <AdminDashBoard />
    </>
  );
}
